var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled } from '@creditas-ui/react';
var DrawerElement = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  z-index: 1000;\n"], ["\n  position: relative;\n  z-index: 1000;\n"])));
export { DrawerElement };
var templateObject_1;
//# sourceMappingURL=Drawer.style.js.map